import { render } from "./HistoryVersionIconNew.vue?vue&type=template&id=09eca47a"
import script from "./HistoryVersionIconNew.vue?vue&type=script&lang=js"
export * from "./HistoryVersionIconNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__